/*
DOCUMENTATION: https://getdatepicker.com/4/


When needing the input to display a default date, add a data attribute to the input like so:

data-defaultdate="{{$order->getInProductionByDate() ? Formatter::formatDateObject($order->getInProductionByDate(), ['includeTime' => true, 'excludeMinutes' => true]) : ''}}"



When including this, the following needs to be included <script src="https://cdnjs.cloudflare.com/ajax/libs/eonasdan-bootstrap-datetimepicker/4.17.49/js/bootstrap-datetimepicker.min.js"></script> before the datetimepicker.min.js):

@section('stylesheets')

@stop

@section('scripts')

@stop
*/


/**
 * Format for just the datepicker is the default, 'L'
 * Format for the datetimepicker is 'L LT', with the sideBySide option set to true
 *
 *
 * @param selectorString
 * @param options
 */
function initializeDateTimePicker(selectorString, options){
    var defaultOptions = {
        icons: {
            time: 'blue icon-time',
            date: 'blue icon-calendar',
            up: 'blue icon-chevron-up',
            down: 'blue icon-chevron-down',
            previous: 'blue icon-chevron-left',
            next: 'blue icon-chevron-right',
            today: 'blue icon-screenshot',
            clear: 'blue icon-trash',
            close: 'blue icon-remove'
        },
        format: 'L',
        showClear: true,
        showClose: true,
    }

    for(var option in options)
        defaultOptions[option] = options[option];

    $(selectorString).each(function(){
        if(!$(this).data('empty'))
            defaultOptions['defaultDate'] = $(this).data('defaultdate');

        $(this).datetimepicker(defaultOptions);
    });
}